<template>
    <div class="Background">
  
      <div style="display: flex;justify-content: space-between">
        <div class="link_location">
          <h2 class="mb-5">
            {{ $store.getters.t('통계') }}<v-icon class="mdi mdi-chevron-right" />
            <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('서비스 전체 통계 (Traffic)') }}</span>

            <v-tooltip bottom color="#eef6ff" style="box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
              <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="ml-2 mdi mdi-information-outline" color="#ccc"/>
              </template>
              <!-- <div style="color: #006CEA;">
              <span style="font-size: 12px;">{{$store.getters.t('스토리지, 인코딩 사용량 미포함')}}</span>
              </div> -->
              <div style="color: #006CEA;">
                <h4>{{ $store.getters.t('서비스별 트래픽 조회') }}</h4>
              <v-divider color="#4d9bf5" class="mt-1 mb-1"></v-divider>
                <span style="font-size: 15px;"><v-icon style="color: rgb(29, 120, 211);" class="mdi mdi-circle-small"/>{{$store.getters.t('하루 전 기준 사용량이 표시됩니다')}}</span><br>
                <span style="font-size: 15px;"><v-icon style="color: rgb(29, 120, 211);" class="mdi mdi-circle-small"/>{{$store.getters.t('스토리지, 인코딩 사용량 미포함')}}</span>
              </div>
            </v-tooltip>
          </h2>
        </div>
        <div ref="datePickerContainer">
          <v-text-field
            ref="dateField"
            v-model="dateRangeText"
            :placeholder="$store.getters.t('시작일-종료일 선택')"
            prepend-inner-icon="mdi-calendar"
            readonly
            @focus="isDatePickerVisible = true"
            outlined
            style="background: #ffffff;"
            dense />

            <v-date-picker
            v-model="dates"
            range
            v-if="isDatePickerVisible"
            @input="onDateChange"
            full-width
            class="data_picker"
            color="#006cea"
            :max="today"
            :min="minDate"
            />
        </div>
      </div>

      <v-row>
        <!-- <v-col class="text-left mt-2">
           <v-btn-toggle multiple v-model="selServiceType" class="mr-3">
                 <TextButton 
                      v-for="(service, index) in serviceList" 
                      :key="index"
                      :buttonText="service" 
                      small 
                      :value="service" 
                  />
            </v-btn-toggle>
            <v-btn-toggle v-model="unitType" class="mr-3">
                <TextButton buttonText="BYTE" small value="B" />
                <TextButton buttonText="MB" small value="MB" />
                <TextButton buttonText="GB" small value="GB" />
            </v-btn-toggle>
        </v-col> -->

        <v-col cols="12" sm="2" class="pt-0 mt-5">
           <v-btn-toggle v-model="selServiceType" class="mr-3">
                 <TextButton
                      v-for="(service, index) in serviceList" 
                      :key="index"
                      :buttonText="service" 
                      small 
                      :value="service" 
                  />
            </v-btn-toggle>
               <!-- <v-chip-group
                v-model="selServiceType"
                column
                active-class="primary--text"
              >
                <v-chip v-for="service in serviceList" :key="service" :value="service" class="custom-chip">
                  {{ service }}
                </v-chip>
              </v-chip-group> -->

              
            <!-- <v-select 
            v-model="selServiceType"
              :items="serviceList"
              item-text="name"
              item-value="id"
              outlined
              dense
              clearable
              chips
            > 
             <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                color="indigo darken-3" 
                class="ma-1"
                small
                outlined
              >
                {{ data.item }}
              </v-chip>
            </template>
            <template v-slot:item="{ item }"> 
              <v-chip small class="ma-1" color="indigo darken-3" outlined>{{ item }}</v-chip>
            </template>

            </v-select> -->
        </v-col>
         
        <v-col class="text-right mt-5">
            <v-btn-toggle class="mr-3" v-model="timeRange">
                <TextButton :buttonText="$store.getters.t ? $store.getters.t('Last 1DAY') : 'Last 1DAY'" small value="1D" />

                <TextButton :buttonText="$store.getters.t ? $store.getters.t('Last 7Day') : 'Last 7Day'" small value="7D" />

                <TextButton :buttonText="$store.getters.t ? $store.getters.t('Last 30Day') : 'Last 30Day'" small value="30D" />
            </v-btn-toggle>
             <v-btn-toggle v-model="unitType" class="mr-3">
                <TextButton buttonText="BYTE" small value="B" />
                <TextButton buttonText="MB" small value="MB" />
                <TextButton buttonText="GB" small value="GB" />
            </v-btn-toggle>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col>
          <UsagebyService 
            :headers="headers"
            :items="dataList"
            :loading="loading"
            :unitType="unitType"
            :search="searchVal"
          ></UsagebyService>
        </v-col>
      </v-row>

      <!-- <v-row v-show="dataList.length > 0">
        <v-card elevation="0" class="mt-2 mb-2" style="width: 100%;">
          <TimeSeries :dataList="dataList" :selServiceType="selServiceType"/>
        </v-card>
      </v-row> -->


      <!--end-->
    </div>
  </template>

<script>
import UsagebyService from '@/components/statistics/allServiceStats/UsagebyService.vue';
import StatisticsApi from "@/api/statistics/StatisticsApi";
import TextButton from '@/components/ui/button/TextButton.vue';
import { mapGetters } from 'vuex';
// import TimeSeries from './TimeSeries.vue';

export default {
    components: {
        UsagebyService,
        TextButton,
        // TimeSeries
    },
    data() {
        return {
            startDate: '',
            endDate: '',
            dates: [],
            isDatePickerVisible: false,
            updateCheck: false,
            startTime: '',
            endTime: '',
            dataList: [],
            loading: false,
            serviceList: [],
            unitType: 'MB',
            selServiceType: 'all',
            initCheck: false,
            dateRangeText: '',
            // headers: this.$store.state.objectData.headers.usageTable,
            chartInstance: null,
            today: '',
            minDate: '',
            timeRange: '1D'
        }
    },
    created(){
      this.defaultDateRange();

      const date = new Date();
      this.today = this.formatDate(date);

      date.setMonth(date.getMonth() - 3);
      this.minDate = this.formatDate(date);

      // console.log("today => ", this.today)
      // console.log("minDate => ", this.minDate)

    },
    mounted(){
      if(sessionStorage.getItem('AccessToken') == null) return;

      // this.fetchData()

      const serviceKeys = ['vod', 'hls', 'webrtc'];

      serviceKeys.forEach((key) => {
        if (this[key]) {
          this.serviceList.push(key);
        } else {
          this.$watch(
            () => this.$store.state.naviList.allowList[key],
            (newVal) => {
              if (newVal === 1) {
                this.serviceList.push(key);
              }
            }
          );
        }
      });

      this.serviceList.unshift('all');

      document.addEventListener("click", this.handleClickOutside);
    },
    methods: {
        async fetchData(){
          this.startTime = this.startDate;
          this.endTime = this.endDate;

          this.loading = true;
          try {
            // const response = await StatisticsApi.serviceUsageApi({ startTime: this.startTime, endTime: this.endTime, serviceArr: this.$store.state.naviList.allowList})
            const response = await StatisticsApi.serviceUsageApi({ startTime: this.startTime, endTime: this.endTime})
            if(response){
              this.dataList = response.list;
              // console.log("response => ", response);
            }
          } catch (error) {
            console.log("error", error);
          } finally {
            this.loading = false;
          }
        },
        updateFlag(data){
          this.loadStatus[data.key] = data.value;
          if(Object.values(this.loadStatus).every(e => e)) {
            this.flag = true;
          }  
        }, 
        onDateChange(newDates) {
            this.timeRange = '';

            if (newDates.start && newDates.end && newDates.start > newDates.end) {
                this.dates.end = this.dates.start;
            } else {
                this.dates = newDates;
            }

            if (this.dates.length === 2) {
                this.startDate = this.dates[0];
                this.endDate = this.dates[1];

                if (this.startDate && this.endDate && this.startDate > this.endDate) {
                    const tmp = this.endDate;
                    this.endDate = this.startDate;
                    this.startDate = tmp;
                }
                this.dateRangeText = `${this.formatDate(this.startDate)} - ${this.formatDate(this.endDate)}`;
                this.isDatePickerVisible = false;

                this.updateCheck = true;
            }
        },
        formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        handleClickOutside(event) {
          if (this.$refs.datePickerContainer && !this.$refs.datePickerContainer.contains(event.target)) {
            this.isDatePickerVisible = false;
          }
        },
        defaultDateRange() {
          const today = new Date();
          const yesterday = new Date();
          yesterday.setDate(today.getDate() - 1);
          this.dateRangeText = `${this.formatDate(yesterday)} ~ ${this.formatDate(yesterday)}`;
          
          this.startDate = this.formatDate(yesterday).trim()
          this.endDate = this.formatDate(yesterday).trim()
        },
        getDateTimeString(date) {
            const offset = 9 * 60 * 60 * 1000;
            const kstDate = new Date(date.getTime() + offset);
            return kstDate.toISOString().replace('T', ' ').substring(0, 19);
        },
        setTimeRange(range) {
          let end = new Date();
          let start = new Date();

          if (range === '1D') {
            this.defaultDateRange();
          } else {
            if (range === '7D') {
              start.setDate(end.getDate() - 6);
            } else if (range === '30D') {
              start.setDate(end.getDate() - 29);
            }

            this.startDate = this.formatDate(start);
            this.endDate = this.formatDate(end);
            this.dateRangeText = `${this.startDate} ~ ${this.endDate}`;
          }
        }
    },
    computed: {
        ...mapGetters('objectData', ['getHeaders']),
        vod() {
            return this.$store.state.naviList.allowList.vod;
        },
        hls() {
            return this.$store.state.naviList.allowList.hls;
        },
        webrtc() {
            return this.$store.state.naviList.allowList.webrtc;
        },
        searchVal(){
          return this.selServiceType === 'all' ? null : this.selServiceType;
        },
        headers(){
          return this.getHeaders('usageTable');
        }
    },
    watch: {
      'dateRangeText' : {
          deep: true,
          immediate: false,
          handler(newVal) {
              // if(this.initCheck){
              //   this.initCheck = true;
              //   this.fetchData();
              // } else {
              //   this.fetchData();
              // }
              if(sessionStorage.getItem('AccessToken') == null) return;

              this.fetchData();
          }
      },
      // dateRangeText(newVal) {
      //    if(sessionStorage.getItem('AccessToken') == null) return;
      //    this.fetchData();
      // },
      timeRange(newVal){
        this.setTimeRange(newVal);
      }
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeChart);
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }
}

</script>

<style lang="scss" scoped>
.data_picker { 
    width: 234px;
    z-index: 99;
    position: absolute;
}
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    width: 234px !important;
}
.v-input__control {
    align-items: end !important;
}
.theme--light.v-input {
    height: 40px !important;
}
.v-text-field input {
    font-size: 14px;
}

// .custom-chip {
//   min-width: 50px; 
//   justify-content: center;
// }

</style>